import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useMatchProfileInfo } from "PFApp/hooks/use_match_profile_info";
import { useProfilePreview } from "PFApp/use_profile_preview";
import { Button } from "PFComponents/button";
import { Typography } from "PFComponents/typography";
import { getProfileName, ObjectWithProfileName } from "PFCore/helpers/profile";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Profile } from "PFTypes";

import css from "./table_cells.module.scss";

type WorkforceMemberCellProps = {
  profile: ObjectWithProfileName & Partial<Profile> & Pick<Profile, "positions">;
};

export const WorkforceMemberCell = ({ profile }: WorkforceMemberCellProps) => {
  const activity = useCurrentActivity();
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  const profileName = getProfileName(profile);
  const { headerInfo: headerProfileInfo } = useMatchProfileInfo(profile);
  const { showPreview } = useProfilePreview();
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const formattedHeaderProfileInfo = headerProfileInfo.map(({ value }) => value).join(", ");

  return (
    <div className={css.profile}>
      {isUnbiasedMode ? (
        <Typography variant="bodyBold" textOverflow="clip">
          {getUnbiasedProfileName(profile, isUnbiasedMode)}
        </Typography>
      ) : (
        <Button
          kind="text"
          text={profileName}
          className={css.profileName}
          onClick={() => showPreview({ id: profile.id, profile: profile as Profile })}
        />
      )}

      {formattedHeaderProfileInfo && (
        <Typography
          variant="labelRegular"
          className={css.profileCustomValues}
          title={formattedHeaderProfileInfo}
          tag="span"
          textOverflow="clip"
        >
          {formattedHeaderProfileInfo}
        </Typography>
      )}
    </div>
  );
};
